$.ajaxSetup({ headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') } });

$(document).ready(function () {
	setTimeout(function () {
		$(".loader").fadeOut(400);
		setTimeout(function () { $(".loader").hide(); }, 500);
	}, 300);

	//backtop
	$(window).scroll(function () {
		var backtop = $('.backtop');
		if ($(this).scrollTop() > 500) {
			backtop.fadeIn(300);
		} else {
			backtop.fadeOut(300);
		}
		if (window.matchMedia("(max-width: 750px)").matches) {
			if ($(window).scrollTop() + $(window).height() == $(document).height()) {
				backtop.css('bottom', '60px');
			} else {
				backtop.css('bottom', '20px');
			}
		}
	});

	$('a.backtop').click(function () { $('body,html').animate({ scrollTop: 0 }, 300); });
});

//hamburger
$(document).on('click', '.hamburger', function () {
	if ($(this).hasClass('down')) {
		$('.desktop_nav').slideUp(300);
		$(this).removeClass("down");
	} else {
		$('.desktop_nav').slideDown(300);
		$(this).addClass("down");
	}
});

//navigation
// if ("ontouchstart" in document.documentElement) {
$(document).on('click', '.navigation .puller', function () {
	if (!window.matchMedia("(max-width: 990px)").matches) {
		return;
	}

	const parent = $(this).parents('li');
	const isOpened = parent.hasClass('opened');

	$('.navigation li').removeClass("opened");
	$('.navigation li ul.sub').slideUp(300)

	if (!isOpened) {
		parent.addClass('opened');
		$('ul.sub', parent).slideDown(300)
	} else {
		$('ul.sub', parent).slideUp(300)
	}
});

//flags
$(document).on('click', '.flags .selected', function () {
	if ($(this).hasClass('active')) {
		$(this).removeClass('active');
		$('.flags .toggle').hide();
	} else {
		$(this).addClass('active');
		$('.flags .toggle').show();
	}
});

//login-mobile
$(document).on('click touchstart', '.login .icon', function () {
	if (window.matchMedia("(max-width: 750px)").matches) {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$('.login .login_wrap').hide();
		} else {
			$(this).addClass('active');
			$('.login .login_wrap').show();
		}
	}
});

//top-search
$(document).on('click', '.top .searcher .icon', function () {
	$('.top .searcher .show_hide, .top .searcher .bg').fadeToggle();
	$('input#top_search_query').focus();


});
//marketplace-filers-mobile
$(document).on('click', '.marketplace.brands .filter_toggle', function () {
	if ($(this).hasClass('show')) {
		$(this).removeClass('show');
		$('.marketplace.brands .toggle').slideUp();
	} else {
		$(this).addClass('show');
		$('.marketplace.brands .toggle').slideDown();
	}
});
//account-filers-mobile
$(document).on('click', '.account .menu_toggle', function () {
	if ($(this).hasClass('show')) {
		$(this).removeClass('show');
		$('.account .toggle').slideUp();
	} else {
		$(this).addClass('show');
		$('.account .toggle').slideDown();
	}
});
$(document).ready(function () {
	//ankers-pageload
	var hash = location.hash.replace('#', '');
	var type = window.location.hash.substr(1);

	if (hash != '') {
		setTimeout(() => {
			$('html, body').animate({
				scrollTop: $('.section[data-anchor="' + type + '"]').offset().top + 0
			}, 1000);
		}, 250);
	}

	//ankers
	$('a.nav_scroller').on('click', function (e) {
		var href = e.target.href;
		var hrefWithoutHash = href.substr(0, href.indexOf('#'));

		var currentHref = window.location.href;
		var currentHrefWithoutHash = currentHref.substr(0, currentHref.indexOf('#'));

		if (!currentHrefWithoutHash || hrefWithoutHash === currentHrefWithoutHash) {
			e.preventDefault();
		} else {
			return true;
		}

		var scrollAnchor = $(this).attr('data-scroll'),
			scrollPoint = $('.section[data-anchor="' + scrollAnchor + '"]').offset().top + 0;
		$('body,html').animate({ scrollTop: scrollPoint }, 1000);
		document.location.hash = $(this).attr('data-scroll');
		return false;
	});
});